import { Box, Drawer, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../Api/ApiError";
import { getTeacherList, LessonTeachers, RegisterTeacher } from "../../Api/OnlineLesson";
import { CustomerInterface } from "../../Objects/Customer";
import PageTitle from "../atoms/PageTitle";
import LessonTeacherList from "../organisms/LessonTeacherList";
import SelectCustomerArea from "../organisms/SelectCustomerArea";

const OnlineLessonPage: React.FC = () => {
    const DISPLAY_ROWS = 6
    let navigate = useNavigate()
    let [lessonTeachers, setLessonTeachers] = React.useState<LessonTeachers>()
    let { enqueueSnackbar } = useSnackbar()
    let [regTeacherOpen, setRegTeacherOpen] = React.useState(false)
    let [pagenum, setPagenum] = React.useState(1)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    let loadTeacherList = React.useCallback(() => {
        getTeacherList({ limit: DISPLAY_ROWS, offset: (pagenum - 1) * DISPLAY_ROWS }, {signal: abortController.signal}).then(res => {
            setLessonTeachers(res)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, pagenum, enqueueSnackbar])

    const doRegister = React.useCallback((customerData: CustomerInterface) => {
        RegisterTeacher(customerData.ctm_id, {signal: abortController.signal}).then(teacher_id => {
            enqueueSnackbar("登録しました", { variant: "success" })
            setRegTeacherOpen(false)
            loadTeacherList()
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, loadTeacherList, enqueueSnackbar])

    React.useEffect(() => {
        loadTeacherList()
    }, [loadTeacherList])

    return (
        <>
            <PageTitle text="オンラインレッスン" />
            {lessonTeachers &&
                <LessonTeacherList
                    lessonTeachers={lessonTeachers}
                    requestRegTeacher={() => {
                        setRegTeacherOpen(true)
                    }}
                    onClick={lessonTeacher => {
                        navigate("/online_lesson/" + lessonTeacher.teacher_id)
                    }}
                    onPageChange={page => {
                        setPagenum(page)
                    }}
                />
            }
            <Drawer
                anchor="bottom"
                open={regTeacherOpen}
                onClose={() => {
                    setRegTeacherOpen(false)
                }}
                sx={{
                    zIndex: 1210
                }}
                PaperProps={{
                    sx: {
                        height: "50%",
                        borderRadius: "1em 1em 0 0"
                    }
                }}
            >
                <Box sx={{ padding: "14px" }}>
                    <Box sx={{ display: "flex", justifyContent: "right" }}>
                        <Button
                            onClick={() => {
                                setRegTeacherOpen(false)
                            }}
                        >閉じる</Button>
                    </Box>
                    <PageTitle text="オンラインレッスン講師登録" />
                    <SelectCustomerArea
                        onSelect={customerData => {
                            doRegister(customerData)
                        }}
                    />
                </Box>
            </Drawer>
        </>
    )
}

export default OnlineLessonPage